// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_loadingContainer__TvxqG {
    position: relative;
}
  
.Loading_loadingOverlay__fHBJV {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px); /* Apply blur effect */
    z-index: 9999; /* Ensure it's above other content */
}

.Loading_loadingGif__sclkH {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000; /* Ensure it's above the overlay */
}
  `, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,gCAAgC;IACtE,mCAA2B;YAA3B,2BAA2B,EAAE,sBAAsB;IACnD,aAAa,EAAE,oCAAoC;AACvD;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc,EAAE,kCAAkC;AACtD","sourcesContent":[".loadingContainer {\r\n    position: relative;\r\n}\r\n  \r\n.loadingOverlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\r\n    backdrop-filter: blur(10px); /* Apply blur effect */\r\n    z-index: 9999; /* Ensure it's above other content */\r\n}\r\n\r\n.loadingGif {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 10000; /* Ensure it's above the overlay */\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `Loading_loadingContainer__TvxqG`,
	"loadingOverlay": `Loading_loadingOverlay__fHBJV`,
	"loadingGif": `Loading_loadingGif__sclkH`
};
export default ___CSS_LOADER_EXPORT___;
